import API from "../common/api"
import { PIIA_AGREEMENT } from "../common/endpoints"

export const agreePiiaService = async () =>{
    const res = await API.post(PIIA_AGREEMENT)
    return res.data
    
}